import {
  Box,
  Button,
  ComponentMultiStyleConfig,
  FormControl,
  Input,
  Link,
  Text,
  useMultiStyleConfig,
} from "@chakra-ui/react";
import React, { useId, useState } from "react";
import { Form } from "react-router-dom";
import { ComponentStyleProps } from "../../../../lib/styles/props/component-style-props";

export type CMFormLoginProps = {
  placeholder?: {
    emailAddress?: string;
    password?: string;
  };
  emailAddress?: string;

  /**
   * パスワード再発行の表示に使用する。
   */
  labelPasswordReissue?: string;

  /**
   * パスワード再発行の遷移先リンクに使用する。
   */
  linkPasswordReissue?: string;
  labelSubmit?: string;
  onSubmit?: (emailAddress: string, password: string) => void;
  isLoading?: boolean;
} & ComponentStyleProps;

/**
 * ログインフォームを表示するコンポーネント
 */
export const CMFormLogin = ({
  placeholder,
  emailAddress,
  labelPasswordReissue,
  linkPasswordReissue,
  labelSubmit,
  onSubmit,
  isLoading = false,
  sx,
  ...rest
}: CMFormLoginProps) => {
  const styles = useMultiStyleConfig("CMFormLoginStyles");
  const [emailAddressValue, setEmailAddress] = useState(emailAddress ?? "");
  const [passwordValue, setPassword] = useState("");

  const id0 = useId();
  const id1 = useId();

  return (
    <FormControl sx={{ ...styles, ...sx }} {...rest}>
      <Form onSubmit={() => onSubmit?.(emailAddressValue, passwordValue)}>
        <Box sx={styles.content}>
          <Box sx={styles.emailAddressInputArea}>
            <Input
              id={id0}
              placeholder={placeholder?.emailAddress}
              value={emailAddressValue}
              onChange={(event) => setEmailAddress(event.target.value)}
              sx={styles.emailAddressInput}
            />
          </Box>
          <Box sx={styles.passwordInputArea}>
            <Input
              id={id1}
              placeholder={placeholder?.password}
              value={passwordValue}
              type={"password"}
              onChange={(event) => setPassword(event.target.value)}
              sx={styles.passwordInput}
            />
          </Box>
          <Box sx={styles.passwordReissueLink}>
            <Link href={linkPasswordReissue}>{labelPasswordReissue}</Link>
          </Box>
          <Box sx={styles.submitButtonArea}>
            <Button
              type={"submit"}
              colorScheme={"teal"}
              sx={styles.submitButton}
              isLoading={isLoading}
            >
              <Text sx={styles.labelSubmit}>{labelSubmit}</Text>
            </Button>
          </Box>
        </Box>
      </Form>
    </FormControl>
  );
};

export const CMFormLoginStyles: ComponentMultiStyleConfig = {
  parts: [
    "content",
    "emailAddressInputArea",
    "emailAddressInput",
    "passwordInputArea",
    "passwordInput",
    "submitButton",
    "labelSubmit",
    "submitButtonArea",
    "passwordReissueLink",
  ],
  baseStyle: {
    content: {
      w: "400px",
    },
    emailAddressInputArea: {
      w: "400px",
      marginBottom: "20px",
    },
    emailAddressInput: {
      bgColor: "white",
      _placeholder: {
        color: "blackAlpha.500",
        fontSize: "sm",
      },
    },
    passwordInputArea: {
      w: "400px",
    },
    passwordInput: {
      bgColor: "white",
      _placeholder: {
        color: "blackAlpha.500",
        fontSize: "sm",
      },
    },
    submitButtonArea: {
      marginTop: "20px",
      textAlign: "center",
      w: "400px",
    },
    submitButton: {
      w: "300px",
    },
    labelSubmit: {
      textOverflow: "ellipsis",
      overflow: "hidden",
      whiteSpace: "nowrap",
    },
    passwordReissueLink: {
      textAlign: "right",
      color: "blue.600",
      fontSize: "xs",
    },
  },
};
